import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { en, zh } from 'make-plural';
import { FC, ReactNode } from 'react';
import { DynamicConfigProvider } from '@ecoflow/ef-ui';
import theme from './theme';
import type { LanguageType } from '@core/constants';
import { remoteVersionSrc, SITES_DATA } from '@core/constants';
import { remoteLoader } from '@lingui/remote-loader';

// 单复数
i18n.loadLocaleData({
    en: { plurals: en },
    us: { plurals: en },
    zh: { plurals: zh },
});

interface I18nProps {
    lang: string;
    messages: any;
    children: ReactNode;
}

/**
 * @desc 获取当前站点
 */
export const getCurrentSite = (i: number) => window.location.pathname.split('/')[i];
/**
 * @desc 获取当前语言
 */
export const getCurrentLang = (i: number) => window.location.pathname.split('/')[i];
/**
 *
 * @desc 获取并设置当前地址语言环境
 */
export function getSiteDataItem(lang: LanguageType) {
    const languageItem = SITES_DATA.find((item) => item.lang === lang) || SITES_DATA[0];

    return languageItem;
}

export const getLatestLocales = async (env: string, lang: string) => {
    try {
        const src = remoteVersionSrc[env as keyof typeof remoteVersionSrc] || remoteVersionSrc.prod;
        const versionRes = await fetch(src, { headers: { 'Cache-Control': 'no-cache' } });
        const remoteVersion = await versionRes.json();
        const langMap = remoteVersion?.data || remoteVersion;
        const remoteRes = await fetch(langMap[lang]);
        const remoteData = await remoteRes.json();
        return remoteLoader({ messages: remoteData });
    } catch (e) {
        console.log(`未应用到远程多语言文件，错误信息：${e}`);
        return {};
    }
};

/**
 * AppI18nProvider
 * @param lang
 * @param messages
 * @returns
 */
export const AppI18nProvider = (props: I18nProps) => {
    i18n.load(props.lang, props.messages);

    i18n.activate(props.lang);

    return <I18nProvider {...props} i18n={i18n} />;
};

/**
 * @desc antd 国际化
 * @param lang
 * @param children
 */
interface UII18nProps {
    lang: string;
    children: ReactNode;
}
export const UII18nConfigProvider: FC<UII18nProps> = (props) => {
    if (!props.lang) {
        console.error('lang not found!');
        return <></>;
    }

    const siteItem = getSiteDataItem(props.lang as LanguageType);

    return (
        <DynamicConfigProvider theme={{ ...theme }} defaultLocale={siteItem.locale}>
            {props.children}
        </DynamicConfigProvider>
    );
};
